import React, { Component } from 'react'
import styled from 'styled-components'
import {Button, Colors} from 'advenio-components'
import PropTypes from 'prop-types' //eslint-disable-line no-console

const PhotoContainer = styled.div`
  width: 50%;
  margin-bottom: 10px;
  margin-top: 30px;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Photo = styled.div`
  height: 300px;
  width: 300px;
  background-image: ${props => props.photo ? 'url(' + props.photo + ')' : ''};
  background-size: cover;
  background-position: center;
`
const FileContainer = styled.div`
  height: 350px;
  width: 300px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  display: inline-block;
  cursor: pointer;
`
const Buttons = styled.button`
  color: #000;
  background-color: transparent;
  padding: 8px 20px;
  height: 50px;
  width: 300px;
  border: solid 0.5px #fff;
  cursor: pointer;
`
const Input = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  height: 350px;
  width: 300px;
  cursor: pointer;
`
const SelectStyled = styled.select`
  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIwLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0LjkgMTAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQuOSAxMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiM0NDQ0NDQ7fQo8L3N0eWxlPgo8dGl0bGU+YXJyb3dzPC90aXRsZT4KPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSIxLjQsNC43IDIuNSwzLjIgMy41LDQuNyAiLz4KPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSIzLjUsNS4zIDIuNSw2LjggMS40LDUuMyAiLz4KPC9zdmc+Cg==) no-repeat right 2px center;;
  background-color: ${({error, disabled}) => {
    return Colors.white300
  }};
  width: 85%;
  height: 34px;
  margin: 20px 0;
  border-radius: 5px;
  border: 1px solid ${Colors.gray300};
  appearance: none;

  &:focus {
    box-shadow: ${({error}) => (error ? `0 0 0 3px ${Colors.advenioRed}` : `0 0 0 3px ${Colors.blue500}`)};
  }
`

class AddPhoto extends Component {
  constructor(props) {
    super(props)

    this.state = {
      photo: '/assets/defaultPhoto.svg',
      file: '',
    }
  }

  onClick = () => {
    this.props.goToView('kidsToSleep', this.props.view,'')
  }

  sendAttachment = (e) => {
    const reader = new FileReader()
    const file = e.target.files[0]
    reader.onloadend = () => {
      this.setState({
        file: file, photo: reader.result
      }, () => this.infoToSend())
    }

    reader.readAsDataURL(file)
  }

infoToSend = () => {
  const { group, category } =  this.props
  let params = {
      category_id: category,
      photo: this.state.photo,
      description_photo: document.getElementById("description_photo").value
    }

  if (group) {
    params = {
      category_id: category,
      photo: this.state.photo,
      description_photo: document.getElementById("description_photo").value
    }
  }

  this.props.setExtraData(params)
}

  getphotoCategory = (props) => {
    const { child, categories, category } = props
    
    const selectCategory =  categories.find(cat => cat.id === category)
    let selectDescriptions = null
    if(child.isDaycare){
      selectDescriptions = selectCategory.photo_description.find(desc => desc.level_id === 1)
    }else{
      selectDescriptions = selectCategory.photo_description.find(desc => desc.level_id === 2)
    }
    return selectDescriptions
  }

render() {
  const category = this.getphotoCategory(this.props)
  return (
    <PhotoContainer>
      <label htmlFor="description_photo">{category.name}</label>
      <SelectStyled name="description_photo" id="description_photo" onChange={() => {this.props.setExtraData({...this.props.info,description_photo: document.getElementById("description_photo").value})}}>
        {category.photo_description_category.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
      </SelectStyled>
      <FileContainer>
        <Photo photo={this.state.photo}/>
        <Input
          type="file"
          name="sendAttachment"
          ref={(input) => this.sendFile = input}
          onChange={this.sendAttachment}
        />
        {this.state.photo === '/assets/defaultPhoto.svg' ?
          <Buttons onClick={() => this.sendFile.click()}>
            Toque para agregar foto
          </Buttons>
          :
          <Buttons onClick={() => this.sendFile.click()}>
            Toque para editar foto
          </Buttons>
        }
      </FileContainer>
      {this.props.group ?
        <Button
          primary
          style={{marginTop: '40px', width: '150px'}}
          onClick={this.onClick}
          disabled={!this.state.file}
        >
          Agregar alumnos
        </Button>
        :
        ''
      }
    </PhotoContainer>
  )
}
}

AddPhoto.propTypes = {
  setExtraData: PropTypes.func.isRequired,
  goToView: PropTypes.func.isRequired,
  child: PropTypes.object,
  view: PropTypes.any,
  group: PropTypes.any,
  category: PropTypes.any,
  info: PropTypes.any,
  categories: PropTypes.array
}

AddPhoto.defaultProps = {
  child: {},
  categories: []
}

export default AddPhoto



// WEBPACK FOOTER //
// ./src/Components/Activity/AddPhoto.jsx